// extracted by mini-css-extract-plugin
export var button = "styles-module--button--0c42c";
export var closeButton = "styles-module--closeButton--538c4";
export var container = "styles-module--container--d96a8";
export var containerActive = "styles-module--containerActive--1c8a8";
export var content = "styles-module--content--11922";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1024px";
export var message = "styles-module--message--75684";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "768px";